import { useEffect, useState, forwardRef } from "react";
import { useSelector } from 'react-redux';
import MultiSelectDropDown from "../form-components/MultiSelectDropDownComponent";
import MultiSelectDropDownForm from "../form-components/MultiSelectDropDownFormComponent";
import { PostRequestCached } from "../generics/helper";

const VehicleModelAutoComplete = forwardRef((props, ref) => {
    const { allOption, selectedValues = [], disabled = false, isFormikFormField = false, showFormError = false, forOem, onlyVehicleMappedModels = false, onlyVehicleLoginBranchMappedModels=false, ...rest } = props;
    let vehicleModelOption = [];
    if (allOption) {
        vehicleModelOption.push({ vehicleModelName: 'All ', vehicleModelId: '' });
    }
    let initialProps = {
        ...rest,
        labelKey: 'vehicleModelName',
        primaryKey: 'vehicleModelId',
        options: vehicleModelOption,
        isObject: true,
        isFormikFormField,
        showFormError,
        dataLoaded: false,
        disabled
    }
    const [defaultProps, setDefaultProps] = useState(initialProps);
    // Get Options
    const userToken = useSelector((state) => state.login.userToken);
    useEffect(() => {
        const getVehicleModelOptions = async () => {
            let getVehicleModelParams = { getFullDetails: 'Y' };
            if (forOem && forOem !== '') {
                getVehicleModelParams = { ...getVehicleModelParams, searchVehicleOemIds: forOem }
            }
            if(onlyVehicleMappedModels){
                getVehicleModelParams = { ...getVehicleModelParams, onlyVehicleMappedModels }

            }
            if(onlyVehicleLoginBranchMappedModels){
                getVehicleModelParams = { ...getVehicleModelParams, onlyVehicleLoginBranchMappedModels }
            }
            // const response = await fetchApi('masters/getVehicleModels',getVehicleModelParams,userToken);
            const response = await PostRequestCached('masters/getVehicleModels', getVehicleModelParams, userToken);

            if (response.status === 'Ok' && response.data.responseStatus === 'Ok') {
                let newOptions = [];
                if (allOption)
                    newOptions.push({ vehicleModelName: 'All', vehicleModelId: "" });

                if (response.data.vehicleModels.length > 0) {
                    newOptions = newOptions.concat(response.data.vehicleModels);
                }
                let preSelectedValues = [];
                if (selectedValues.length > 0) {
                    preSelectedValues = newOptions.filter((ur) => selectedValues.indexOf(ur.vehicleModelId) >= 0);
                }
                const newProps = { ...defaultProps, options: newOptions, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        getVehicleModelOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forOem]);

    useEffect(() => {
        if (selectedValues.length > 0 && defaultProps.options.length > 0) {
            let preSelectedValues = [];
            if (selectedValues.length > 0) {
                preSelectedValues = defaultProps.options.filter((vm) => selectedValues.indexOf(vm.vehicleModelId) >= 0);
                const newProps = { ...defaultProps, preSelectedValues, dataLoaded: true }
                setDefaultProps(newProps);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValues,defaultProps.options]);

    useEffect(() => {
        const newProps = { ...defaultProps, disabled, dataLoaded: true }
        setDefaultProps(newProps);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [disabled]);
    return (defaultProps.dataLoaded ?
        !isFormikFormField ?
            <MultiSelectDropDown
                ref={ref}
                {...defaultProps}
            /> :
            <MultiSelectDropDownForm
                ref={ref}
                {...defaultProps}
            /> : <></>
    );
});

export default VehicleModelAutoComplete;